import styled from 'styled-components';

import { Flex } from '@/components/base';

const StyledRow = styled(Flex).attrs({
  a: 'center',
})`
  flex-shrink: 0;
  height: 82px;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray300};
  transition: all 0.2s;
  min-width: fit-content;
  &:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }
`;

const StyledSentimentTrendChartWrapper = styled(Flex).attrs({
  a: 'center',
  j: 'center',
})`
  width: 100%;
  height: 100%;
`;

const StyledCol = styled(Flex).attrs({
  a: 'center',
})`
  height: 100%;
  position: relative;
  &.col-name {
    min-width: 200px;
  }
  &.col-negative {
    min-width: 160px;
  }
  &.col-trend {
    flex: 1;
    width: auto;
    min-width: 310px;
    &.body-row {
      border-left: 1px solid ${(props) => props.theme.colors.gray300};
      border-right: 1px solid ${(props) => props.theme.colors.gray300};
    }
  }
  &.col-sentence {
    min-width: 300px;
    flex: 1;
  }
  &.col-agent {
    min-width: 160px;
  }
`;

type StyledChartLabelsProps = {
  offset: number;
};

const StyledChartLabels = styled(Flex)<StyledChartLabelsProps>`
  position: relative;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 0 ${(props) => props.offset}px;

  .labels-wrapper {
    position: relative;
    width: 100%;
  }

  .label {
    position: absolute;
    bottom: 4px;
    white-space: nowrap;
  }
`;

const CustomerTableStyles = {
  StyledRow,
  StyledCol,
  StyledSentimentTrendChartWrapper,
  StyledChartLabels,
};

export default CustomerTableStyles;
